import React from "react";
import { styled, Typography } from "@mui/material";

const TextInput = ({ color, children, fontWeight, fontSize }) => {
  const InputText = styled(Typography)(({ theme }) => ({
    fontFamily: theme.typography,
    color: color ? color :   "#263057",
    fontSize: fontSize ? fontSize : 12,
    fontWeight: fontWeight ? fontWeight : "",
  }));

  return <InputText>{children}</InputText>;
};

export default TextInput;
